import { createReducer } from '../../utils';

export const initialState = { };

const ACTION_HANDLERS = { };

export default createReducer(ACTION_HANDLERS, initialState);
